import { render, staticRenderFns } from "./CouponFilters.vue?vue&type=template&id=33c8f608&scoped=true&"
import script from "./CouponFilters.vue?vue&type=script&lang=js&"
export * from "./CouponFilters.vue?vue&type=script&lang=js&"
import style0 from "./CouponFilters.vue?vue&type=style&index=0&id=33c8f608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8f608",
  null
  
)

export default component.exports